/**
 @ngdoc directive
 @name shortcut

 @description
 Simulates a click event on the parent element when the given shortcut is provided

 @usage
 <a href="<targetUrl>" shortcut="control+shift+d">
 */

(function () {
  "use strict";
  var shortcutDirective = function () {
    return {
      restrict: "A",
      controllerAs: "ctrl",
      controller: function ($scope, $element, $attrs) {

        const modifiersCheck = ["alt", "shift", "control"];

        this.$onInit = function () {
          document.addEventListener("keydown", function (event) {
            if (
              getKey().toLowerCase() === event.key.toLowerCase() &&
              hasModifiers(event)
            ) {
              $element[0].click();
            }
          });
        };

        const hasModifiers = function (event) {
          let modifiersAreHeld = true;
          getModifiers().forEach(function (modifier) {
            if (!event.getModifierState(modifier)) modifiersAreHeld = false;
          });
          return modifiersAreHeld;
        };

        const getModifiers = function () {
          let modifiers = $attrs.shortcut
            .split("+")
            .filter(function (modifier) {
              return modifiersCheck.includes(
                modifier.trim().toLowerCase()
              );
            });
          modifiers = modifiers.map(function (modifier) {
            return modifier.trim();
          });
          return modifiers.map(function (modifier) {
            return modifier.charAt(0).toUpperCase() + modifier.slice(1);
          });
        };

        const getKey = function () {
          return $attrs.shortcut
            .split("+")
            .filter(function (keyCode) {
              return !modifiersCheck.includes(
                keyCode.trim().toLowerCase()
              );
            })[0]
            .trim()
            .toLowerCase();
        };
      },
    };
  };

  angular.module("app").directive("shortcut", shortcutDirective);
})();
